import * as React from "react";
import { forwardRef } from "react";
const SvgCompletedSubStep = ({
  title,
  titleId,
  ...props
}, ref) => /* @__PURE__ */ React.createElement("svg", { width: 12, height: 12, viewBox: "0 0 12 12", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("circle", { cx: 6, cy: 6, r: 5, fill: "#1561D1", stroke: "#0F172A", strokeWidth: 2 }));
const ForwardRef = forwardRef(SvgCompletedSubStep);
export { ForwardRef as ReactComponent };
